import React, { type Dispatch, type SetStateAction } from 'react';

import { AppleLoginButton } from '@/app/[locale]/(auth)/components/AppleLoginButton';
import { GoogleLoginButton } from '@/app/[locale]/(auth)/components/GoogleLoginButton';

export type SocialLoginProps = {
  nonce: string;
  handleError: Dispatch<SetStateAction<string>>;
  setIsAccountLinkingError: Dispatch<SetStateAction<boolean>>;
};

export function SocialLogin({
  nonce,
  handleError,
  setIsAccountLinkingError,
}: SocialLoginProps) {
  return (
    <>
      <GoogleLoginButton
        nonce={nonce}
        setError={handleError}
        setIsAccountLinkingError={setIsAccountLinkingError}
      />
      <AppleLoginButton
        setError={handleError}
        setIsAccountLinkingError={setIsAccountLinkingError}
      />
    </>
  );
}
